

export const veoFeatures = {
    title: 'AI 影片生成的核心功能',
    subtitle:
      '先進模型帶來電影級影像能力：關鍵幀控制、延長時長、多張參考圖、原生音訊。',
    items: [
      { num: '01', title: '關鍵幀控制：精準起始/結尾幀', body: '以關鍵幀精準掌控影片開頭與結尾，建立平滑過渡並維持敘事流暢。' },
      { num: '02', title: '多張參考圖：一致視覺風格', body: '提供多張參考圖以引導角色、打光、色調，確保全片視覺一致。' },
      { num: '03', title: '原生音訊與強化音效', body: '自動生成對白、環境音與動作同步音效，與畫面完美對齊。' },
      { num: '04', title: '延長影片時長（超越 8 秒）', body: '突破 8 秒限制，讓敘事自然延續，創作更豐富的影片。' }
    ]
  };
